import { PropsWithChildren } from 'react'
import { ConfigProvider as AntdConfigProvider } from '@vivaldis/antd-ui'
import { VivaldisTheme } from '@vivaldis/ui'

export const ConfigProvider = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <AntdConfigProvider appTheme={VivaldisTheme}>{children}</AntdConfigProvider>
  )
}
